import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';
import { MEIOptantePipe } from './pipes';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        MEIOptantePipe
    ],
    exports: [
        MEIOptantePipe
    ]
})
export class MEIModule { }
